import React from 'react';
import Button from '~ComponentsImproved/Button';
import { useI18n } from '~Hooks';
import { PaymentMethod } from '~reducers';

interface PaymentMethodSelectorProps {
  onSelect: (method: PaymentMethod) => void;
  methods: PaymentMethod[];
}

const PaymentMethodSelector = ({ methods, onSelect }: PaymentMethodSelectorProps) => {
  const { i18n } = useI18n();

  return (
    <div style={{ width: '100%' }}>
      <h3>{i18n('GiftCard.SelectPaymentMethod')}</h3>
      {methods.map((method) => (
        <Button
          key={method.id}
          onTouchStart={() => onSelect(method)}
          text={method.title}
          styleType="Confirm"
          style={{ marginBottom: '8px' }}
        />
      ))}
    </div>
  );
};

export default PaymentMethodSelector;
